import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Table,
  Button,
  Form,
  Tooltip,
  Popconfirm,
  Select,
  List,
} from "antd";
import {
  UnorderedListOutlined,
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";
import { convertColumns } from "../../../../utils/columnconverter";
import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import { useTranslation } from "react-i18next";
import { noWhitespace } from "../../../../utils/rules";

import Technology from "../../../Technologies/technology";
import TechnologySubcategory from "../../../Technologies/technologySubcategory";
import TechnologyType from "../../../Technologies/technologyType";

const Technologies = (props) => {
  const mainUrl = "Auth/register";
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [positions, setPositions] = useState([]);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [reset, setReset] = useState(null);

  const [columns, setColumns] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Technology");

  const { notify } = props;
  const cols = [
    { key: "index", value: "#", con: true },
    { key: "userName", value: t("name"), con: true },
    { key: "image", value: "Şəkil", con: true },
    { key: "id", value: "", con: true },
  ];

  const defaultColumns = [
    {
      title: "#",
      key: "1",
      dataIndex: "index",
      width: 80,
    },
    {
      title: t("name"),
      key: "2",
      dataIndex: "name",
    },
    {
      title: "",
      key: "3",
      dataIndex: "id",
      width: 30,
      render: (i) => {
        return (
          <div className="flex flex-end">
            <Popconfirm
              placement="topRight"
              title={t("areYouSure")}
              onConfirm={() => deletePosition(i)}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Tooltip className="ml-5" title={t("delete")}>
                <Button className="border-none" type="text" shape="circle">
                  <DeleteFilled />
                </Button>
              </Tooltip>
            </Popconfirm>
            <Tooltip className="ml-5" title={t("edit")} placement="topRight">
              <Button
                className="border-none"
                type="text"
                shape="circle"
                onClick={() => setEditing(i)}
              >
                <EditFilled />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const categorySpecificColumns = {
    TechnologySubcategory: [
      {
        title: " kateqoriya",
        key: "4",
        dataIndex: "technologyCategory",
        render: (i) => {
          return <p>{i?.name}</p>;
        },
      },
    ],
    TechnologyType: [
      {
        title: "alt kateqoriya",
        key: "5",
        dataIndex: "technologySubcategory",
        render: (i) => {
          return <p>{i?.name}</p>;
        },
      },
      {
        title: " kateqoriya",
        key: "6",
        dataIndex: "technologyCategory",
        render: (i) => {
          return <p>{i?.name}</p>;
        },
      },
    ],
  };

  const { Option } = Select;

  const deletePosition = async (i) => {
    await aictia
      .delete(`${selectedCategory}/${i}`)
      .then(() => {
        // description
        notify("silindi", true);
        getPositions();
      })
      .catch((err) => {
        //error
        notify(err.response, false);
      });
  };

  const getPositions = async () => {
    setSpin(true);
    await aictia.get(selectedCategory).then((res) => {
      setSpin(false);
      setPositions(
        res.data.map((p, index) => {
          return {
            key: index + 1,
            ...p,
            index: index + 1,
          };
        })
      );
    });
  };
  const columnsfunc = () => {
    let newColumns = [...defaultColumns];
    if (selectedCategory && categorySpecificColumns[selectedCategory]) {
      const categoryColumns = categorySpecificColumns[selectedCategory];
      newColumns.splice(-1, 0, ...categoryColumns);

    }
    setColumns(newColumns);
  };
  useEffect(() => {
    getPositions();

    columnsfunc();
  }, [t, selectedCategory]);

  return (
    <Row gutter={[10, 10]} className="pl-1">
      <Col xs={24}>
        <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
          <span
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: "#eff6ff",
              color: "#0c82f4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 10,
              marginTop: 5,
            }}
          >
            <UnorderedListOutlined className="f-20" />
          </span>
          <div>
            <span className="f-20 bold">{t('technologies')}</span>
            <p className="text-[11px] text-slate-450 font-medium">{t("technologiesSub")}</p>
          </div>
        </div>
      </Col>

      {/* <Col xs={12}>
        <div className="form-lang">
          <Form.Item
            name={"Technologies"}
            validateTrigger="onChange"
            rules={[noWhitespace(t("inputError"))]}
          >
            <Select
              defaultValue="Texnologiyalar kateqoriyasının adı"
              onChange={(e) => setSelectedCategory(e)}
            >
              <Option key={1} value={"Technology"}>
                Texnologiyalar kateqoriyasının adı
              </Option>
              <Option key={2} value={"TechnologySubcategory"}>
                Texnologiyaların alt kateqoriyasının adı
              </Option>
              <Option key={3} value={"TechnologyType"}>
                Texnologiyaların növ adı
              </Option>
            </Select>
          </Form.Item>
        </div>
        <Col lg={24} xs={24}>
          <Table
            loading={spin}
            size="small"
            className="bg-white animated fadeInLeft"
            columns={columns}
            dataSource={convertColumns(positions, cols)}
            pagination={{
              pageSize: 10,
              current_page: 1,
              total: positions.length,
            }}
          />
        </Col>
      </Col> */}

      <Col xs={12}>
        <div
          className="ant-card ant-card-bordered ant-card-shadow"
          style={{
            border: "1px solid rgba(226,232,240,.85)",
            borderRadius: 16,
            overflow: "hidden",
            boxShadow: "0 1px 2px rgba(15,23,42,.04)",
          }}
        >
          {/* HEADER */}
          <div
            style={{
              borderBottom: "1px solid #f0f0f0",
              padding: "12px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  textTransform: "uppercase",
                }}
              >
                Texnologiyalar
              </div>

              <div
                style={{
                  fontSize: 10,
                  color: "#999",
                  fontWeight: 600,
                }}
              >
                TEXNOLOGİYA MƏLUMATLARININ İDARƏ EDİLMƏSİ
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "4px 10px",
                background: "#f8fafc",
                border: "1px solid rgba(226,232,240,.9)",
                borderRadius: 12,
              }}
            >
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 900,
                  color: "#475569",
                  textTransform: "uppercase",
                  letterSpacing: "0.6px",
                }}
              >
                Kateqoriya:
              </span>

              <Form.Item
                name="Technologies"
                validateTrigger="onChange"
                rules={[noWhitespace(t("inputError"))]}
                style={{ marginBottom: 0 }}
              >
                <Select
                  defaultValue="Texnologiyalar kateqoriyasının adı"
                  onChange={(e) => setSelectedCategory(e)}
                  size="small"
                  bordered={false}
                  style={{
                    minWidth: 240,
                    background: "transparent",
                  }}
                  dropdownStyle={{
                    borderRadius: 12,
                  }}
                >
                  <Option value="Technology">
                    Texnologiyalar kateqoriyasının adı
                  </Option>

                  <Option value="TechnologySubcategory">
                    Texnologiyaların alt kateqoriyasının adı
                  </Option>

                  <Option value="TechnologyType">
                    Texnologiyaların növ adı
                  </Option>
                </Select>
              </Form.Item>
            </div>
          </div>

          {/* TABLE */}
          <div
            style={{
              padding: 12,
              background: "#fff",
            }}
          >
            <List
              loading={spin}
              grid={{
                gutter: 12,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              dataSource={convertColumns(positions, cols)}
              locale={{ emptyText: "Siyahı boşdur." }}
              renderItem={(item, index) => (
                <List.Item style={{ border: "none", padding: 0 }}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      background: "#f8fafc",
                      border: "1px solid rgba(226,232,240,.9)",
                      borderRadius: 12,
                      padding: "10px 14px",
                    }}
                  >
                    {/* INDEX */}
                    <div
                      style={{
                        width: 50,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{
                          minWidth: 22,
                          height: 22,
                          padding: "0 6px",
                          background: "#fff",
                          border: "1px solid #cfd6df",
                          borderRadius: 6,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 11,
                          fontWeight: 700,
                          fontFamily: "monospace",
                        }}
                      >
                        {index + 1}
                      </span>
                    </div>

                    {/* TECHNOLOGY NAME */}
                    <div
                      style={{
                        flex: 1,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#111827",
                      }}
                    >
                      {item.name}
                    </div>

                    {/* ACTIONS */}
                    <div
                      style={{
                        width: 90,
                        display: "flex",
                        justifyContent: "center",
                        gap: 10,
                      }}
                    >
                      <EditFilled
                        onClick={() => setEditing(item.id)}
                        style={{
                          fontSize: 15,
                          color: "#64748b",
                          cursor: "pointer",
                        }}
                      />

                      <DeleteFilled
                        onClick={() => deletePosition(item.id)}
                        style={{
                          fontSize: 15,
                          color: "#64748b",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
      </Col>

      {selectedCategory === "Technology" && (
        <Col lg={12} xs={24}>
          <Technology
            id={editing}
            setEditing={setEditing}
            getPositions={getPositions}
          />
        </Col>
      )}
      {selectedCategory === "TechnologySubcategory" && (
        <Col lg={12} xs={24}>
          <TechnologySubcategory
            id={editing}
            setEditing={setEditing}
            getPositions={getPositions}
          />
        </Col>
      )}
      {selectedCategory === "TechnologyType" && (
        <Col lg={12} xs={24}>
          <TechnologyType
            id={editing}
            setEditing={setEditing}
            getPositions={getPositions}
          />
        </Col>
      )}
    </Row>
  );
};

const mapStateToProps = ({ langs }) => {
  return {
    langs: langs,
  };
};

export default connect(mapStateToProps, { notify })(Technologies);
